import { i18n } from '@/common/locale';

export const getEventTypeKeys = () => ({
  assetConfiguration: {
    key: 'Asset Configuration',
    eventType: i18n.global.t('WORD.ALERT_SERVER_CHANGE.ASSET_CONFIGURATION_CHANGE'),
  },
  environmentVariables: {
    key: 'Environment Variables',
    eventType: i18n.global.t('WORD.ALERT_SERVER_CHANGE.ENVIRONMENT_VARIABLE_CHANGE'),
  },
  software: {
    key: 'Software',
    eventType: i18n.global.t('WORD.ALERT_SERVER_CHANGE.SOFTWARE_CHANGE'),
  },
  routingPath: {
    key: 'Routing Path',
    eventType: i18n.global.t('WORD.ALERT_SERVER_CHANGE.ROUTING_PATH_CHANGE'),
  },
});

export const getEventNameKeys = () => ({
  assetConfiguration: [
    {
      eventName: 'OS Version',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.OS_VERSION'),
      value: 'osVersion',
    },
    {
      eventName: 'CPU Architecture',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_ARCHITECTURE'),
      value: 'cpuArch',
    },
    {
      eventName: 'CPU Physical Core',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_PHYSICAL_CORE'),
      value: 'cpuPhysical',
    },
    {
      eventName: 'CPU Logical Core',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_LOGICAL_CORE'),
      value: 'cpuLogical',
    },
    {
      eventName: 'System Boot Time',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.SYSTEM_BOOT_TIME'),
      value: 'systemBootTime',
    },
    {
      eventName: 'HostName',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.HOST_NAME'),
      value: 'hostName',
    },
    {
      eventName: 'Kernel Version',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.KERNEL_VERSION'),
      value: 'kernelVersion',
    },
    {
      eventName: 'CPU Vendor ID',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_VENDOR_ID'),
      value: 'cpuVendorId',
    },
    {
      eventName: 'CPU Model Name',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_MODEL_NAME'),
      value: 'cpuModelName',
    },
    {
      eventName: 'CPU MHz',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_MHZ'),
      value: 'cpuMHz',
    },
    {
      eventName: 'CPU Cache Size',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_CACHE_SIZE'),
      value: 'cpuCacheSize',
    },
    {
      eventName: 'CPU Family',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_FAMILY'),
      value: 'cpuFamily',
    },
    {
      eventName: 'CPU Model',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_MODEL'),
      value: 'cpuModel',
    },
    {
      eventName: 'CPU Stepping',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.CPU_STEPPING'),
      value: 'cpuStepping',
    },
    {
      eventName: 'Total Memory Size',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.TOTAL_MEMORY_SIZE'),
      value: 'totalMemorySize',
    },
    {
      eventName: 'IP Address List',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.IP_ADDRESS_LIST'),
      value: 'ipAddressList',
    },
    {
      eventName: 'MAC Address List',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.MAC_ADDRESS_LIST'),
      value: 'macAddressList',
    },
  ],
  environmentVariables: [
    {
      eventName: 'System Environment Variables',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.SYSTEM_ENVIRONMENT_VARIABLES'),
      value: 'systemEnv',
    },
  ],
  software: [
    {
      eventName: 'Number of Installed Packages',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.NUMBER_OF_INSTALLED_PACKAGES'),
      value: 'packageCount',
    },
    {
      eventName: 'Installed Package List',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.INSTALLED_PACKAGE_LIST'),
      value: 'installPackageList',
    },
  ],
  routingPath: [
    {
      eventName: 'Number of Destination Networks',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.NUMBER_OF_DESTINATION_NETWORKS'),
      value: 'destinationNetworkCount',
    },
    {
      eventName: 'Routing Table List',
      description: i18n.global.t('WORD.ALERT_SERVER_CHANGE.ROUTING_TABLE_LIST'),
      value: 'routingTableList',
    },
  ],
});

export const getEventTypeRows = () => {
  const eventNameInfo = getEventNameKeys();

  return Object.entries(getEventTypeKeys()).flatMap(([key, info]) => {
    return eventNameInfo[key].map(({ value, ...rest }) => ({
      ...rest,
      eventType: info.eventType,
      keyValue: { key: info.key, value },
    }));
  });
};
